import axios from "axios";
import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, FormGroup, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { Link } from "react-router-dom";
import Loading from "../../../components/loading/Loader";
import PaginateCard from "../../../components/PaginateCard";
import CompanyEnum from "../../../enums/company/CompanyEnum";
import useUserInformation from "../../../hooks/useUserInformation";
import MainMenu from "../../../modules/public/mainMenu/mainMenu";
import baseUrl from "../../../modules/utility/baseUrl";
import PrintLink from "../../../components/shipment/Factor/PrintLink";

const AfterRentReport = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [showNumber, setShowNumber] = useState(25);
  const [startNumber, setStartNumber] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [company, setCompany] = useState("");
  const [status, setStatus] = useState("");
  const [numberParcel, setNumberParcel] = useState("");

  const { agent } = useUserInformation();

  const path =
    baseUrl +
    `/totalpost/v1/agent/show/cod/${agent.id}?numberpage=${pageNumber}&numberitems=${showNumber}
    &fromDate=${fromDate}&toDate=${toDate}&company=${company}&status=${status}&numberParcel=${numberParcel}
    
    `;

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: response } = await axios.get(path);
      setData(response);
    } catch (error) {
      console.error(error.message);
    }
    setStartNumber((pageNumber - 1) * showNumber + 1);

    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, [pageNumber, showNumber]);

  var optionArew = (
    <div>
      <div className="mb-5">
        <p style={{ fontSize: 20, textAlign: "center", color: "#4E148C" }}>
          گزارش مرسولات پس کرایه
        </p>
      </div>
      <Row>
        <Col xl={4} lg={4} md={4} sm={12}>
          <FormGroup>
            <Form.Label> تعداد نمایشی:</Form.Label>

            <Form.Select onChange={e => setShowNumber(e.target.value)}>
              <option>10</option>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </Form.Select>
          </FormGroup>
        </Col>
        <Col xl={4} lg={4} md={4} sm={12}>
          <FormGroup>
            <Form.Label> سرویس دهنده:</Form.Label>

            <Form.Select
              onChange={e => {
                setCompany(e.target.value);
              }}
            >
              <option value="">همه</option>
              {Object.keys(CompanyEnum).map(item => (
                <option key={item} value={item}>
                  {CompanyEnum[item]}
                </option>
              ))}
            </Form.Select>
          </FormGroup>
        </Col>

        <Col xl={4} lg={4} md={4} sm={12}>
          <FormGroup>
            <Form.Label> وضعیت:</Form.Label>

            <Form.Select
              id="disabledSelect"
              onChange={e => {
                setStatus(e.target.value);
              }}
            >
              <option value="">همه</option>
              <option value="تایید نهایی">تایید نهایی</option>
              <option value="جمع آوری نشده">جمع آوری نشده</option>
              <option value="ارجاع به راننده">ارجاع به راننده</option>
              <option value="معلق">معلق در فروشگاه</option>
              <option value="تحویل داده شده">در حال جابجایی</option>
              <option value="برگشتی">برگشتی</option>
              <option value="تحویل مشتری">تحویل مشتری</option>
              <option value="لغو شده">لغو شده</option>
              <option value="لغو موقت">لغو موقت</option>
            </Form.Select>
          </FormGroup>
        </Col>
        <Col lg={4} md={4} sm={12} style={{ marginTop: 1 }}>
          <Form.Label> از تاریخ:</Form.Label>
          <DatePicker
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            style={{ width: "100%", height: "2.2rem" }}
            name="fromDate"
            //format='yyyy-MM-dd'
            // value={this.state.sDateMyPack}
            onChange={value => {
              setFromDate(new DateObject(value));
            }}
          />
          {/* <DateObject/> */}
        </Col>
        <Col lg={4} md={4} sm={12} style={{ marginTop: 1, marginRight: 180 }}>
          <Form.Label> تا تاریخ:</Form.Label>
          <DatePicker
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            style={{ width: "100%", height: "2.2rem" }}
            name="toDate"
            // value={}
            onChange={value => {
              setToDate(new DateObject(value));
            }}
          />
        </Col>

        <Col xl={6} lg={6} md={6} sm={12} className="mt-3 , mb-4">
          <FormGroup>
            <Form.Label> شماره بارنامه:</Form.Label>
            <Form.Control
              type="number"
              onChange={e => {
                setNumberParcel(e.target.value);
              }}
            />
          </FormGroup>
        </Col>

        <Col lg={6} md={6} sm={12} className="mb-2 mt-4 text-center">
          <Button className="mt-4 btn btn-warning" onClick={() => fetchData()}>
            اعمال فیلتر
          </Button>
        </Col>
      </Row>
    </div>
  );

  var table = (
    <>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <p style={{ fontSize: 20 }}> تعداد کل : {data.count}</p>
        <p style={{ fontSize: 20, marginRight: "5rem", color: "red" }}>
          لغو شده : {data.cancelled_count}
        </p>
        <p style={{ fontSize: 20, marginRight: "5rem", color: "#FF6600" }}>
          در انتظار تایید مالی : {data.notConfirmed_count}
        </p>
        <p style={{ fontSize: 20, marginRight: "5rem", color: "green" }}>
          تایید مالی شده : {data.delivered_count}
        </p>
      </div>

      <div className="w-100 overflow-x-scroll px-2">
        <Table striped bordered={true} style={{ textAlign: "center" }}>
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره بارنامه</th>
              <th>تاریخ</th>
              <th>مبلغ فاکتور</th>
              <th>مبلغ COD</th>
              <th>سرویس دهنده</th>
              <th>نوع پرداخت</th>
              <th>وضعیت</th>
              {/* <th>سهم آواکس</th> */}
              <th>پورسانت نماینده</th>
              <th>توضیحات</th>
              <th>تایید مالی</th>
            </tr>
          </thead>

          <tbody>
            {data.result?.map((item, index) => (
              <tr key={index}>
                <td>{index + startNumber}</td>
                <td>
                  <PrintLink ids={[item.id]}>{item.numberParcel}</PrintLink>
                </td>
                <td>
                  {moment(item.formatted_created_at, "YYYY/MM/DD")
                    .locale("fa")
                    .format("YYYY/MM/DD")}
                </td>
                <td>{item.realPayable.toLocaleString()} ریال </td>
                <td>{item.amountCOD.toLocaleString()} ریال </td>

                <td>
                  <span>{CompanyEnum[item.componyId]}</span>
                </td>

                {item.amountCOD > 0 ? (
                  <td>{item.MethodPayment}</td>
                ) : (
                  <td>پس کرایه</td>
                )}
                {item.componyId == 1}

                {item.status == "معلق" && <td>معلق در فروشگاه</td>}

                {item.status == "تحویل داده شده" && <td>در حال جابجایی</td>}
                {item.status !== "معلق" && item.status !== "تحویل داده شده" && (
                  <td>{item.status}</td>
                )}
                <td>
                  {item.wallet_agent
                    .reduce((a, v) => (a = a + v.amount), 0)
                    .toLocaleString()}
                  ریال
                </td>

                <td>{item.wallet_agent.description}</td>
                {item.status == "تحویل مشتری" ? (
                  <td style={{ color: "green" }}>موفق</td>
                ) : (
                  <td style={{ color: "red" }}>در انتظار</td>
                )}

                {/* <td>
                <Icon.Eye
                  color="#4B1483"
                  onClick={() => {}}
                  title="مشاهده جزئیات فاکتور"
                />
            </td> */}
                {/* <td> </td>  */}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );

  var excelBtn = (
    <Link
      className="btn btn-success fw-bold px-2"
      download={true}
      style={{ marginTop: 25 }}
      to={`${baseUrl}/totalpost/v1/agent/show/cod-excel/${agent.id}?fromDate=${fromDate}&toDate=${toDate}&company=${company}&status=${status}&numberParcel=${numberParcel}`}
    >
      دانلود فایل اکسل
    </Link>
  );

  var total = (
    <Container className="d-flex flex-column justify-content-center  align-items-center ">
      <Card className="w-100" style={{ marginTop: 35 }}>
        {optionArew}
        {loading ? <Loading /> : table}
        {/* {table} */}
        {/* {paginate} */}
        {/* {modal} */}
        <PaginateCard
          numberItems={showNumber}
          numberPage={pageNumber}
          onIndexChoose={number => setPageNumber(number)}
          count={data.count}
        />
        {excelBtn}
      </Card>
    </Container>
  );

  return <MainMenu data={total} />;
};

export default AfterRentReport;
